import CustomReplacement from './format';

const NAME = 'customReplacements';

class CustomReplacements {
    constructor() {}
}

export const name = NAME;
export const handler = CustomReplacements;
export const formats = [CustomReplacement];
